<div class="container" >

<div class="ticket_board_btn my-4 pl-2">
  <button type="button"  [ngClass]="{'is_active': activeFilter==filterEnum.All}"  class="btn btn_tickets" (click)="onChangeFilter(filterEnum.All)" >All Tickets</button>
  <button  type="button" [ngClass]="{'is_active': activeFilter==filterEnum.My}" class="btn btn_tickets" (click)="onChangeFilter(filterEnum.My)" >My Tickets</button>
  <button  type="button" [ngClass]="{'is_active': activeFilter==filterEnum.None}" class="btn" (click)="onChangeFilter(filterEnum.None)" >Clear All</button>
</div>



<div class="row wrapper">
  <div cdkDropList #toDoList="cdkDropList" [cdkDropListData]="toDo" [cdkDropListConnectedTo]="[inProgressList]"
    class="col-5 row-fields" (cdkDropListDropped)="drop($event)">
    <div class="tickets_board">
      <h2 class="board_title">To Do</h2>
      <div *ngFor="let item of toDo" class="column ticket" cdkDrag [cdkDragDisabled]="true">
        <div class="ticket_title_andlabel d-flex justify-content-between align-items-center mb-3">
          <h3 class="ticket_title mb-0"><span >{{item.SUBJECT}}</span></h3>
          <div class="label_andmodule">
            <p class="ticket_label ticket_priority_high">{{item.ISSUE_TYPE}}</p>
            <span *ngIf="item.TYPE" class="ticket_module">{{item.TYPE}}</span>
          </div>
        </div>

        <div class="d-flex justify-content-between">
          <div class="d-flex w-60 align-items-center">
            <!-- Avatar -->
            <app-assignee-profie-info [assignee]="item?.CREATED_BY" [size]="24"
              *ngIf="item?.CREATED_BY?.FIRST_NAME && item?.CREATED_BY?.LAST_NAME"></app-assignee-profie-info>
            <p class="ticket_asignee mb-0">{{item.CREATED_BY?.getName()}}</p>
          </div>
          <p class="title_create_date w-40  mb-0">{{item.CREATED_DATE | date:'medium'}}</p>
        </div>

      </div>
    </div>
  </div>

  <div class="col-5 row-fields">
    <div cdkDropList #inProgressList="cdkDropList" [cdkDropListData]="inProgress" [cdkDropListConnectedTo]="[toDoList]"
      (cdkDropListDropped)="drop($event)" class="tickets_board">
      <h2 class="board_title">In Progress</h2>
      <div *ngFor="let item of inProgress" class="item-column ticket" cdkDrag [cdkDragDisabled]="true">
        <div class="ticket_title_andlabel d-flex justify-content-between align-items-center mb-3">
          <h3 class="ticket_title mb-0"><span >{{item.SUBJECT}}</span></h3>
          <div class="label_andmodule">
            <p class="ticket_label ticket_priority_high">{{item.ISSUE_TYPE}}</p>
            <span class="ticket_module">{{item.TYPE}}</span>
          </div>
        </div>

        <div class="d-flex justify-content-between">
          <div class="d-flex align-items-center">
            <app-assignee-profie-info [assignee]="item?.CREATED_BY" [size]="24"
            *ngIf="item?.CREATED_BY?.FIRST_NAME && item?.CREATED_BY?.LAST_NAME"></app-assignee-profie-info>
            <p class="ticket_asignee mb-0">{{item.CREATED_BY?.getName()}}</p>
          </div>
          <p class="title_create_date  mb-0">{{item.CREATED_DATE | date:'medium'}}</p>
        </div>


      </div>
    </div>
  </div>
</div>
</div>